module.exports = __webpack_public_path__ + "img/1457048782.9267a937.jpg";